import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ModalWindow, Select, useLocalizeMessage } from 'libs.nucleus';
import { useUserRoles } from 'libs.react_internal';
import { DataReportsContext } from '../../../contexts/data_reports/data_reports.context';
export const TestEnvironmentSelector = ({ isOpen, onClose, onEnvironmentSelected, environmentOptions, }) => {
    const translate = useLocalizeMessage();
    const navigate = useNavigate();
    const { isSiteUser } = useUserRoles();
    const { studyId } = useParams();
    const { testEnvironmentsOptions, selectedTestEnv, setSelectedTestEnv } = useContext(DataReportsContext);
    const options = environmentOptions ?? testEnvironmentsOptions;
    const [localSelectedTestEnv, setLocalSelectedTestEnv] = useState(selectedTestEnv);
    const handleEnvironmentChange = (option) => {
        setLocalSelectedTestEnv(option);
    };
    const handleContinue = () => {
        if (localSelectedTestEnv.value) {
            setSelectedTestEnv(localSelectedTestEnv);
            onEnvironmentSelected();
        }
    };
    const handleGoBackToReportList = () => {
        navigate(`/studies/${studyId}/data/reports`);
    };
    return (_jsx(ModalWindow, { title: translate('Select environment'), isOpen: isOpen, closeWindow: onClose, footerPrimaryActionButton: {
            label: translate('Continue to report'),
            onClick: handleContinue,
            disabled: !localSelectedTestEnv.value,
        }, footerSecondaryActionButtons: isSiteUser
            ? undefined
            : [
                {
                    label: translate('Go back to report list'),
                    onClick: handleGoBackToReportList,
                },
            ], children: _jsxs("div", { className: 'space-y-6', children: [_jsx("p", { className: 'text-base font-medium', children: translate('Please select a test environment to see this report.') }), _jsxs("div", { className: 'space-y-3 h-[250px]', children: [_jsxs("label", { children: [translate('Test environment'), " ", _jsx("span", { className: 'text-red-500', children: "*" })] }), _jsx(Select, { placeholder: translate('--Select--'), options: options || [], value: localSelectedTestEnv, onChange: handleEnvironmentChange, width: 'full' })] })] }) }));
};
